import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { NitroPanel, NitroText } from 'nitro-components';

import { connect } from 'react-redux';

import FilterConnectorIndicator from '../../Filters/components/FilterConnectorIndicator';
// import { getBusinessReports, getReportsCCAndCountry } from '../../../selector';

import { RULES, OPERATORS, FilterTypeMap } from '../../Filters/Helpers';

import { translateFilterSummary } from '../../../report-edit/filters';

const OPERATERS = [
  {
    value: 'include',
    label: 'Include'
  },
  {
    value: 'exclude',
    label: 'Exclude'
  }
];

const CONDITIONS = [
  {
    value: 1,
    label: 'staring with'
  },
  {
    value: 2,
    label: 'end with'
  },
  {
    value: 3,
    label: 'contains'
  }
];

const Content = styled.div``;

const FilterSection = styled.section`
  font-size: 16px;
  color: ${props => props.theme.color.base1};
  line-height: 50px;
  word-spacing: 4px;
`;
const KeyWord = styled(NitroText)`
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    bottom: -4px;
    height: 1px;
    background: ${props => props.theme.color.border};
    left: 0;
  }
`;

const Filters = ({ filters, fields, reportFilters }) => {
  const summFilters = translateFilterSummary(filters);
  return (
    <Content>
      {summFilters.map((filterGroup, index) =>
        <div key={index}>
          <NitroPanel boxShadowLight  padding="8px 20px">
            {filterGroup.map((filter, i) =>
              <FilterSection key={i}>
                <div>
                  <KeyWord bold size="2" variant="secondary">
                    {RULES.find(f => f.value === filter.rule).label}
                  </KeyWord>
                  {' results with in '}
                  <KeyWord bold size="2" variant="primary">
                    {reportFilters.find(f => f.id === filter.field).title}
                  </KeyWord>
                </div>
                <div>
                  <KeyWord bold size="2" variant="secondary">
                    {OPERATORS.find(c => c.value === filter.operator).label}
                  </KeyWord>
                  {' the term '}
                  <KeyWord bold size="2" variant="secondary">
                    {filter.label}
                  </KeyWord>
                </div>
                {i !== filterGroup.length - 1 && <FilterConnectorIndicator label="OR" layout="horizontal" noLine />}
              </FilterSection>
            )}
          </NitroPanel>

          {index !== filters.length - 1 && <FilterConnectorIndicator label="AND" layout="vertical" noLine />}
        </div>
      )}
    </Content>
  );
};

Filters.propTypes = {};

// TODO: move to selector
const mapStateToProps = state => {
  const { filters, fields, reportFilters } = state.reports;


  return { filters, fields, reportFilters };
};

export default connect(mapStateToProps)(Filters);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Summary/Sections/Filters.js